import { NavLink } from "react-router-dom";
import { Home, CalendarDays, Plus, Heart, CircleUserRound } from "lucide-react";

const Item = ({ to, icon: Icon, label, id, end }) => (
  <NavLink to={to} end={end} data-testid={`nav-${id}`}
    className={({ isActive }) => `relative flex flex-1 flex-col items-center gap-1 pt-3 pb-2 text-[11px] leading-tight transition-colors duration-200 ${isActive ? "text-[#F8C872]" : "text-[#F7F4EE]/85"}`}>
    {({ isActive }) => (
      <>
        <Icon size={24} strokeWidth={1.5} fill={isActive && id === "home" ? "currentColor" : "none"} />
        <span className="text-center">{label}</span>
        <span className={`mt-1 h-[3px] w-9 rounded-full bg-[#F8C872] transition-opacity duration-200 ${isActive ? "opacity-100" : "opacity-0"}`} />
      </>
    )}
  </NavLink>
);

const Divider = () => <span className="my-4 w-px bg-[#E6A45D]/20" />;

export const BottomNav = () => (
  <nav data-testid="bottom-nav" className="md:hidden fixed bottom-0 left-1/2 z-40 w-full max-w-[430px] -translate-x-1/2 rounded-t-[24px] border-t border-[#E6A45D]/25 bg-[#0b0907]/95 backdrop-blur-xl safe-bottom">
    <div className="flex items-stretch px-1">
      <Item to="/" end icon={Home} label="Accueil" id="home" />
      <Divider />
      <Item to="/events" icon={CalendarDays} label="Événements" id="events" />
      <Divider />
      <NavLink to="/instant" data-testid="nav-instant" className={({ isActive }) => `flex flex-1 flex-col items-center gap-1 pb-2 text-[11px] leading-tight ${isActive ? "text-[#F8C872]" : "text-[#F7F4EE]/85"}`}>
        <span className="btn-gold -mt-5 h-14 w-14 !rounded-full"><Plus size={30} strokeWidth={1.6} /></span>
        <span className="text-center">Créer<br />mon Instant</span>
      </NavLink>
      <Divider />
      <Item to="/reservations" icon={Heart} label={<>Mes<br />réservations</>} id="reservations" />
      <Divider />
      <Item to="/account" icon={CircleUserRound} label="Mon compte" id="account" />
    </div>
  </nav>
);
